// extracted by mini-css-extract-plugin
module.exports = {"Container":"Credit_Container__R3UJi","Label":"Credit_Label__7tKHP","Content":"Credit_Content__HhZ_N","Collapsed":"Credit_Collapsed__7B5Ga","Top":"Credit_Top__WZwhF"};